// extracted by mini-css-extract-plugin
export var subtitle = "_8q-2";
export var title = "_8q-0";
export var titleNoWrap = "_8q-1";